import { render, staticRenderFns } from "./FrequenciesForm.vue?vue&type=template&id=9b55a48e&"
import script from "./FrequenciesForm.vue?vue&type=script&lang=js&"
export * from "./FrequenciesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports